import { FC, useState } from 'react'
import { ColorResult, RGBColor, SketchPicker } from 'react-color'

type ColorPickerProps = {
    color: RGBColor,
    setColor: (newColor: ColorResult) => void
}

const ColorPicker: FC<ColorPickerProps> = (props) => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    // const [color, setColor] = useState({ r: 241, g: 112, b: 19, a: 1, } as RGBColor);
    const styles = {
        color: {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            background: `rgba(${props.color.r}, ${props.color.g}, ${props.color.b}, ${props.color.a})`,
        },
        swatch: {
            padding: '12px',
            cursor: 'pointer',
        },
        popover: {
            color: '#0000ff',
            position: 'absolute',
            zIndex: '2',
        },
        cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        },
    };

    return (
        <div>
            <div style={styles.swatch} onClick={() => setDisplayColorPicker(!displayColorPicker)}>
                <div style={styles.color} />
            </div>
            {displayColorPicker ? <div style={styles.popover as any}>
                <div style={styles.cover as any} onClick={() => setDisplayColorPicker(false)} />
                <SketchPicker color={props.color} onChange={props.setColor} />
            </div> : null}

        </div>
    )
}

export default ColorPicker;